export default "__VITE_ASSET__DEMT83pz__"